import {
  SpaceBetween,
  ColumnLayout,
  Grid,
} from "@cloudscape-design/components-themed";
import { CompanyInfoForBankAccount } from "../../../features/api-interfaces";
import { changeStyle } from "../../../utils/format";
import InfoField from "../../UI/InfoField";
import { LABELS } from "../constants";

interface IPaymentTargetCompanyReference {
  isFetching: boolean;
  paymentTargetCompany?: CompanyInfoForBankAccount;
  isModalOpen: boolean;
}

/**
 * 入金口座情報照会 入金先事業者情報
 */
export const PaymentTargetCompanyReference = (
  props: IPaymentTargetCompanyReference
) => {
  const { isFetching, paymentTargetCompany, isModalOpen } = props;
  const postalCode = paymentTargetCompany?.postalCode;
  const displayAddress = [
    postalCode ? changeStyle(postalCode) : "　",
    "　",
    paymentTargetCompany?.address ?? "　",
  ].join("");

  return (
    <>
      {isModalOpen ? (
        <SpaceBetween direction={"horizontal"} size={"xxl"}>
          <ColumnLayout columns={4}>
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"h4"}
              values={[
                LABELS.COMPANY_NAME,
                LABELS.COMPANY_NAME_KANA,
                LABELS.CORPORATE_NUMBER,
                LABELS.ADDRESS,
                LABELS.ADDRESS_OTHERS,
                LABELS.ADDRESS_KANA,
                LABELS.PHONE_NUMBER,
              ]}
            />
          </ColumnLayout>
          <ColumnLayout columns={4}>
            <InfoField
              direction={"vertical"}
              size={"xxxs"}
              tag={"p"}
              values={[
                paymentTargetCompany?.companyName,
                paymentTargetCompany?.companyNameKana,
                paymentTargetCompany?.corporateNumber,
                displayAddress,
                paymentTargetCompany?.addressDetails,
                paymentTargetCompany?.addressKana,
                paymentTargetCompany?.phoneNumber,
              ]}
            />
          </ColumnLayout>
        </SpaceBetween>
      ) : (
        <SpaceBetween direction={"vertical"} size={"xxs"}>
          <Grid
            gridDefinition={[
              { colspan: 2 },
              { colspan: 4 },
              { colspan: 1 },
              { colspan: 5 },
            ]}
          >
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"h4"}
              values={[LABELS.COMPANY_NAME]}
            />
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"p"}
              values={[
                isFetching
                  ? "　"
                  : paymentTargetCompany?.companyName ?? LABELS.SAME_INFO,
              ]}
            />
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"h4"}
              values={[LABELS.CORPORATE_NUMBER]}
            />
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"p"}
              values={[paymentTargetCompany?.corporateNumber]}
            />
          </Grid>
          <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"h4"}
              values={[LABELS.COMPANY_NAME_KANA]}
            />
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"p"}
              values={[paymentTargetCompany?.companyNameKana]}
            />
          </Grid>
          <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"h4"}
              values={[LABELS.ADDRESS]}
            />
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"p"}
              values={[displayAddress]}
            />
          </Grid>
          <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"h4"}
              values={[LABELS.ADDRESS_OTHERS]}
            />
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"p"}
              values={[paymentTargetCompany?.addressDetails]}
            />
          </Grid>
          <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"h4"}
              values={[LABELS.ADDRESS_KANA]}
            />
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"p"}
              values={[paymentTargetCompany?.addressKana]}
            />
          </Grid>
          <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"h4"}
              values={[LABELS.PHONE_NUMBER]}
            />
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"p"}
              values={[paymentTargetCompany?.phoneNumber]}
            />
          </Grid>
        </SpaceBetween>
      )}
    </>
  );
};
